export type SnSearchbarOptionClickHandler = () => void;
